import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Edit } from '@mui/icons-material';
import {
  Typography,
  Grid,
  Collapse,
  MenuItem,
  Tooltip,
  Button
} from '@mui/material';
import moment from 'moment';
import { useSelector } from 'react-redux';
import Strings from '../../../i18n';
import { ItemDetail } from '../../../components/itemDetail/itemDetail';
import { ApplicationDetailsProps } from './applicationDetailsProps';
import { ButtonStyledDetails, CustomSelect } from './applicationDetailsStyles';
import { colors } from '../../../constants/colors';
import { viewRightSideBarEnum } from '../../../constants/sidebarEnums';
import { locationDetails } from '../../../store/slices/locations/location';
import { DeleteButtonPlainText } from '../../../components/commons/DeleteButtonPlainText/deleteButtonPlainText';
import { DeleteButtonWithValidation } from '../../../components/commons/DeleteButtonWithValidation/deleteButtonWithValidation';

export const ApplicationsDetails = ({
  collapse,
  openRightSideBarForMethod,
  makeDefaultLocation,
  deleteLocation,
  resetLocation
}: ApplicationDetailsProps) => {
  const locationSelected = useSelector(locationDetails);
  return (
    <Collapse in={collapse}>
      <Grid container paddingLeft="17%">
        <ItemDetail
          nameProperty={Strings.applications.createdBy}
          value={locationSelected?.createdByEmail}
        />
        <ItemDetail
          nameProperty={Strings.applications.createdAt}
          value={moment(locationSelected?.creationDate).format('MM/DD/YYYY')}
        />
        <ItemDetail
          nameProperty={Strings.applications.locationType}
          component={
            <Button
              variant="text"
              color="info"
              size="small"
              endIcon={<Edit />}
              onClick={() =>
                openRightSideBarForMethod(
                  viewRightSideBarEnum.changeLocationType
                )
              }
            >
              {locationSelected?.locationTypeName}
            </Button>
          }
        />
        <ItemDetail
          nameProperty={Strings.applications.latLong}
          component={
            <Button
              variant="text"
              color="info"
              endIcon={<Edit />}
              size="small"
              onClick={() =>
                openRightSideBarForMethod(
                  viewRightSideBarEnum.changeLatLongLocation
                )
              }
            >
              {`${locationSelected?.geoInfo?.latitude.toString()} / ${locationSelected?.geoInfo?.longitude.toString()}`}
            </Button>
          }
        />
        <ItemDetail
          nameProperty={Strings.applications.consoleControls}
          component={
            <Grid container marginLeft={-1}>
              <Grid item xs={12} marginTop={-1}>
                <ButtonStyledDetails
                  buttonColor={colors.darkGray}
                  onClick={() => makeDefaultLocation()}
                  variant="text"
                  size="small"
                  endIcon={
                    <Tooltip
                      arrow
                      title={Strings.applications.makeDefault}
                      placement="top"
                    >
                      <InfoOutlinedIcon />
                    </Tooltip>
                  }
                >
                  {Strings.applications.makeDefault}
                </ButtonStyledDetails>
                <ButtonStyledDetails
                  buttonColor={colors.orange}
                  onClick={() =>
                    openRightSideBarForMethod(
                      viewRightSideBarEnum.transferLocation
                    )
                  }
                  variant="text"
                  size="small"
                  endIcon={
                    <Tooltip
                      arrow
                      title={Strings.applications.transferLoc}
                      placement="top"
                    >
                      <InfoOutlinedIcon />
                    </Tooltip>
                  }
                >
                  {Strings.locations.transferOwnership}
                </ButtonStyledDetails>
              </Grid>
            </Grid>
          }
        />
        <ItemDetail
          nameProperty={Strings.locations.resetLocation}
          component={
            <DeleteButtonWithValidation
              onDelete={() => resetLocation()}
              titleConfirmation={Strings.locations.resetLocation}
              textConfirmation={Strings.common.thisActionIsIrreversible}
              textIcon={Strings.locations.resetLocation}
              textValidation={`${
                Strings.locations.resetLocationConfirmationWord
              } "${Strings.common.reset.toUpperCase()}"`}
              showDeleteIcon={false}
              colorBtn="warning"
              validationKey={Strings.common.reset.toUpperCase()}
            />
          }
        />
        <ItemDetail
          nameProperty={Strings.locations.deleteLocation}
          component={
            <DeleteButtonPlainText
              onDelete={() => deleteLocation()}
              titleConfirmation={Strings.locations.deleteLocation}
              textConfirmation={Strings.common.thisActionIsIrreversible}
              textIcon={Strings.locations.deleteLocation}
              showDeleteIcon
            />
          }
        />
      </Grid>
    </Collapse>
  );
};
